import VDMDashboardStoppages from "components/app/vdmdashboard/stoppages/VDMDashboardStoppages";
import React from "react";

type ScreenVDMDashboardStoppagesType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardStoppages: React.FC<ScreenVDMDashboardStoppagesType> = (
	props: ScreenVDMDashboardStoppagesType
) => {
	return <VDMDashboardStoppages vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardStoppages;